(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["collection-template"]) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    var $desc = $('.SectionHeader__Description');
    if (!$desc.length) return;

    var words = $desc.text().trim().split(' ');
    if (words.length > 40) {
      $desc.addClass('truncate');
      $desc.after(
        '<p class="read-more"><span onclick="handleReadMore()" tabindex="0" aria-label="Read more about this product" role="button" aria-expanded="false">[read more]</span></p>'
      );
      window.handleReadMore = function () {
        $desc.removeClass('truncate');
        $desc.next().remove();
      };
    }
  });

  } catch(e) { console.error(e); }
})();
})();
